/* @flow */
/* Make a promise cancelable.
 * When the promise is canceled, it goes thought the reject chain passing {isCanceled: true}
 *
 * https://facebook.github.io/react/blog/2015/12/16/ismounted-antipattern.html
 * https://github.com/facebook/react/issues/5465#issuecomment-157888325
 *
 * const cancelablePromise = makeCancelable(somePromise);
 *
 * cancelablePromise
 *   .promise
 *   .then(() => console.log('resolved'))
 *   .catch((reason) => console.log('isCanceled', reason.isCanceled));
 *
 * cancelablePromise.cancel(); // Cancel the promise
 */
export function makeCancelable(promise: Promise<*>) {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(function(val) {
      return hasCanceled_ ? reject({ isCanceled: true }) : resolve(val);
    }).catch(function(error) {
      return hasCanceled_ ? reject({ isCanceled: true }) : reject(error);
    });
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
}

export type CancelablePromise = {
  promise: Promise<*>,
  cancel: () => void,
};

/**
 * Generally should be replaced with a purposeful catch
 */
// $FlowFixMe
export function genericCatch (...args): void {
  console.warn('genericCatch', ...args);
}



// WEBPACK FOOTER //
// ./src/lib/promise.js